<template>
  <CollaboratorFormModal
    ref="formModal"
    :scope="scope"
    :available-roles="availableRoles"
    :limits-usage="limitsUsage"
    :can-bypass-limits="canBypassLimits"
    entry-type="email"
    header-icon="cipUsersPlus"
    :show-personal-message="false"
    modal-class="modal-a-user"
    :entry-placeholder="$gettext('name@example.com (press Enter to add)')"
    @submit="handleSubmit"
  >
    <template #title>
      <translate translate-context="collaborators.assign">Assign Collaborators</translate>
    </template>

    <template #description>
      <div class="font-weight-medium mb-1">
        <translate translate-context="collaborators.assign">Direct Assignment (No Invitation)</translate>
      </div>
      <p>
        <translate translate-context="collaborators.assign">Users will be added as collaborators without sending an
          invitation email. They must already have an account on the platform.
        </translate>
      </p>
    </template>

    <template #entry-label>
      <translate translate-context="collaborators.assign">Email addresses</translate>
    </template>

    <template #entry-count-label>
      <translate translate-context="collaborators.assign">email(s)</translate>
    </template>

    <template #submit-text>
      <translate translate-context="collaborators.assign">Assign Collaborators</translate>
    </template>

    <template #no-roles-text>
      <translate translate-context="collaborators.assign">No roles available for assignment in this event.</translate>
    </template>
  </CollaboratorFormModal>
</template>

<script>
import {mapActions} from 'vuex'
import CollaboratorFormModal from './CollaboratorFormModal.vue'

export default {
  name: 'AssignCollaboratorModal',

  components: {
    CollaboratorFormModal
  },

  props: {
    scope: {
      type: Object,
      required: true
    },
    availableRoles: {
      type: Array,
      default: () => []
    },
    limitsUsage: {
      type: Object,
      default: null
    },
    canBypassLimits: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions('collaborators', [
      'assignCollaborators',
      'fetchCollaborators'
    ]),

    open() {
      this.$refs.formModal.open()
    },

    close() {
      this.$refs.formModal.close()
    },

    async handleSubmit({entries, roleIds}) {
      try {
        const result = await this.assignCollaborators({
          users: entries,
          roles: roleIds
        })

        if (result.success && result.success.length > 0) {
          const successMsg = this.$pgettext('collaborators.notification', '{count} collaborators assigned successfully')
          await this.notifySuccess(successMsg.replace('{count}', result.success.length))
        }

        if (result.errors && Object.keys(result.errors).length > 0) {
          const errorMessages = Object.entries(result.errors)
            .map(([email, error]) => {
              if (typeof error === 'object' && error.code) {
                return `${email}: ${this.$refs.formModal.translateLimitError(error.code, error.detail)}`
              }
              return `${email}: ${this.$refs.formModal.translateLimitError(error)}`
            })
            .join('\n')
          await this.notifyError(
            this.$pgettext('collaborators.notification', 'Some operations failed:\n') + errorMessages
          )
        }

        this.close()
        await this.fetchCollaborators()
        this.$emit('assigned')
      } catch (error) {
        const errorCode = error.data?.code
        const errorMessage = this.$refs.formModal.translateLimitError(errorCode, error.data?.detail)
        await this.notifyError(errorMessage)
      }
    }
  }
}
</script>
